import { AvailableUsers } from '../types/customer';

export const isActiveUserB2B = (users: AvailableUsers): boolean => {
  return users.activeUser.customerType === 'business';
};
